import './Cards.css';

export default function Cards({content}) {
    return (
        <>
            <div className="cardCenter">
                <div className="cardExterior">
                    {content}
                    <div className="cardInterior"/>
                </div>
            </div>
        </>
    )
}